module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/7-546cbb236cf66d1b06d530993bc890bd.png";